import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { LangService } from 'src/app/core/services/lang.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Employee } from '../../../models/employee.model';
import { fixedValues } from 'src/app/shared/constants/fixed-values.enum';

@Component({
  selector: 'app-voucher-access-list',
  templateUrl: './../../../templates/forms/modals/voucher-access-list.component.html',
})
export class VoucherAccessListComponent implements OnInit {

  @ViewChild('modalContainer', { static: true, read: ViewContainerRef }) container;

  @Input()
  config: any;

  @Input()
  modalShow: boolean = true;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any;

  @Input()
  employeeList:Employee[];
  typeName: string;
  private modal:ModalService;
  public searchString;

  constructor(public langService: LangService) {
  }

  ngOnInit() {
  }

  onClickAddNewEmployee() {
    this.employeeList.push(new Employee());
  }

  onClickOpenEmployeeListModal(employee) {
    this.modal.createEmployeeListComponent(this.container, employee);
  }

  onClickRemoveEmployeeListModal(index, employee) {
    if(employee.SQL_STATE == 1) {
        this.employeeList.splice(index, 1);
    }
    else {
      employee.SQL_STATE = fixedValues.sqlState.sqlDelete;
    }
  }

}
